import React from 'react';
import './itp-vehicule-utilitare.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import {
  FaShieldAlt,
  FaClock,
  FaCheckCircle,
  FaCertificate,
  FaWeightHanging,
  FaWarehouse,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClipboardCheck,
  FaIdCard,
  FaFileAlt,
  FaFileContract,
  FaFileSignature,
  FaHeadset
} from 'react-icons/fa';

// Imagini specifice utilitare/marfă — de înlocuit cu fotografii proprii din service
const images = {
  hero: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmz--f_RG3gWGqzaCONKO4-m0JB8PcSzroqCtwb5PJ-w&s=10",
  qualified: "https://images.pexels.com/photos/4489749/pexels-photo-4489749.jpeg",
  zoneServicii: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzcc6inUbxld4jSJGoYZVBTnMQ7lUOOWrfN03rBsEAgw&s",
  zoneAproape: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsKDqqWM5_lMeia1Pn2RzvlwFcCkISlLTsSjD4JJLBFw&s=10",
  priceN1: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMhbUK6P46YsHMn7T5B7QpbPYQCgObIYqSTRGjAtBjBg&s=10",
  priceN2: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJrDcv1YVMJ6GtHvz80gqIm410KePqnRoASCkbLGf5tQ&s=10",
  priceM3: "https://www.etctrucks.ro/files/home/Stoc%20vehicule/1089/WhatsApp%20Image%202021-03-10%20at%2015.28.37.jpeg",
  priceUtilaje: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGfNZ651gHihsGb8zJR95MJThxbkl_sOZeI32H2-niyg&s=10",
};

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": "ITP Vehicule Utilitare Sector 2",
  "areaServed": [
    "Sector 2 București", "Pantelimon", "Colentina", "Obor", "Iancului",
    "Titan", "Vitan", "Baicului", "Fundeni"
  ],
  "priceRange": "RON",
  "telephone": "+40726104358"
};

const ItpVehiculeUtilitarePage = () => {
  return (
    <div className="itp-util-layout">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <Navbar />

      {/* HERO */}
      <section className="util-hero">
        <div className="util-hero-container">
          <div className="util-hero-image-side">
            <img
              src={images.hero}
              alt="ITP vehicule utilitare Sector 2 - dube si autoutilitare, statie autorizata RAR"
              className="util-hero-image"
            />
          </div>
          <div className="util-hero-text-side">
            <span className="itp-eyebrow"> Stație ITP utilitare autorizată RAR</span>
            <h1>ITP Vehicule Utilitare Sector 2 București</h1>
            <p>
              Ai o dubă, o autoutilitară sau o flotă de transport marfă? La <strong>ITP Sector 2</strong> efectuăm
              <strong> inspecția tehnică periodică</strong> pentru vehicule N1, N2 și N3, cu emiterea pe loc a certificatului ITP.
            </p>
            <p>
              Stația noastră de <strong>ITP utilitare București</strong> are linie de testare dimensionată pentru vehicule comerciale
              (frâne, sarcină pe punte, suspensie, emisii) și program flexibil pentru șoferi profesioniști. Acoperim rapid
              <strong> Sector 2</strong> și zonele apropiate: Pantelimon, Colentina, Obor, Iancului și Titan.
            </p>

            <div className="util-trust-row">
              <span className="util-trust-chip"><FaShieldAlt /> Autorizare RAR</span>
              <span className="util-trust-chip"><FaClock /> Programare rapidă pe flotă</span>
              <span className="util-trust-chip"><FaCheckCircle /> Preț fix pe tonaj</span>
            </div>

            <a href="tel:+40726104358" className="btn-ticket"><FaPhoneAlt /> Programează ITP utilitare</a>
          </div>
        </div>
      </section>

      {/* DE CE SĂ NE ALEGI */}
      <section className="util-why-section">
        <div className="util-why-header">
          <span className="itp-eyebrow">De ce noi</span>
          <h2>Gândit pentru vehicule de marfă și flote</h2>
          <p>Dube, autoutilitare și camioane ușoare au nevoi diferite față de un autoturism obișnuit — noi lucrăm zilnic cu ele.</p>
        </div>
        <div className="util-why-grid">
          <div className="util-why-card">
            <div className="util-why-icon"><FaWeightHanging /></div>
            <h3>Testare pe sarcină utilă</h3>
            <p>Verificăm frânele și suspensia raportat la greutatea reală de exploatare, nu doar la gol.</p>
          </div>
          <div className="util-why-card">
            <div className="util-why-icon"><FaWarehouse /></div>
            <h3>Capacitate pentru flote</h3>
            <p>Programăm mai multe vehicule din aceeași flotă în aceeași zi, pentru minim timp de nefuncționare.</p>
          </div>
          <div className="util-why-card">
            <div className="util-why-icon"><FaHeadset /></div>
            <h3>Suport pentru șoferi profesioniști</h3>
            <p>Program adaptat cursei zilnice, cu prioritate pentru vehiculele care nu pot sta pe loc.</p>
          </div>
        </div>
      </section>

      {/* CUM FUNCȚIONEAZĂ */}
      <section className="util-process-section">
        <div className="util-process-header">
          <span className="itp-eyebrow">Proces simplu</span>
          <h2>Cum funcționează programarea</h2>
          <p>Patru pași, gândiți pentru vehicule care nu au timp de pierdut.</p>
        </div>
        <div className="util-process-grid">
          <div className="util-process-step">
            <div className="util-process-num"><FaPhoneAlt /></div>
            <h3>Suni sau completezi programarea</h3>
            <p>Ne spui categoria vehiculului: N1, N2 sau flotă.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaMapMarkerAlt /></div>
            <h3>Vii în stația din Sector 2</h3>
            <p>Aproape de Pantelimon, Colentina și Obor.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaClipboardCheck /></div>
            <h3>Verificare tehnică RAR</h3>
            <p>Testăm frâne, suspensie, sarcină și emisii.</p>
          </div>
          <div className="util-process-step">
            <div className="util-process-num"><FaCertificate /></div>
            <h3>Primești certificatul ITP</h3>
            <p>Eliberat pe loc, valabil la nivel național.</p>
          </div>
        </div>
      </section>

      {/* ECHIPĂ CALIFICATĂ */}
      <section className="util-qualified-section">
        <div className="util-qualified-container">
          <div className="util-qualified-image-side">
            <img src={images.qualified} alt="Mecanic verificand o autoutilitara la ITP Sector 2" />
            <div className="util-qualified-badge"><FaShieldAlt /> Stație autorizată RAR</div>
          </div>
          <div className="util-qualified-text-side">
            <h2>Calificați pentru transport marfă și flote comerciale</h2>
            <p>
              De la o dubă de curierat la un camion ușor cu remorcă, aplicăm aceeași rigoare tehnică pentru fiecare
              <strong> ITP utilitare</strong> efectuat în stația din Sector 2.
            </p>
            <ul className="util-checklist">
              <li><FaCheckCircle /> Test frâne pe sarcină</li>
              <li><FaCheckCircle /> Verificare suspensie & șasiu</li>
              <li><FaCheckCircle /> Control sistem remorcare</li>
              <li><FaCheckCircle /> Test emisii poluante</li>
            </ul>
          </div>
        </div>
      </section>

      {/* TARIFE */}
      <section className="util-prices-section">
        <div className="util-prices-header">
          <span className="itp-eyebrow">Tarife 2026</span>
          <h2>Tarife ITP Vehicule Utilitare Sector 2</h2>
          <p>Prețuri fixe, pe categorie de tonaj. Pentru flote, oferim programare grupată.</p>
        </div>
        <div className="util-prices-grid">

          <div className="util-price-card">
            <img className="util-price-image" src={images.priceN1} alt="ITP dube si autoutilitare N1 pana la 3.5 tone" />
            <div className="util-price-content">
              <h3>Autoutilitare (pana in 3,5 tone)</h3>
              <p className="util-price-tag">250 <span>RON</span></p>
              <p className="util-price-details">Verificare completă pentru vehicule de marfă cu masă maximă autorizată de până la 3.5 tone.</p>
              <button className="util-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          <div className="util-price-card popular">
            <img className="util-price-image" src={images.priceN2} alt="ITP camioane usoare N2 cu remorca" />
            <div className="util-price-content">
              <h3>Autoutilitare (mai grele de 3,5 tone)</h3>
              <p className="util-price-tag">300 <span>RON</span></p>
              <p className="util-price-details">Include verificarea sistemului de remorcare și testare pe sarcină pentru vehicule mai grelee de 3,5 tone.</p>
              <button className="util-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          <div className="util-price-card popular">
            <img className="util-price-image" src={images.priceM3} alt="ITP camioane usoare N2 cu remorca" />
            <div className="util-price-content">
              <h3>Microbuze M2 - M3</h3>
              <p className="util-price-tag">250 - 300 <span>RON</span></p>
              <p className="util-price-details"> Vehicule cu mai mult de 8 locuri pe scaune (în afară de locul șoferului) și o masă maximă autorizată de până la 5 tone.</p>
              <button className="util-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>


           <div className="util-price-card popular">
            <img className="util-price-image" src={images.priceUtilaje} alt="ITP camioane usoare N2 cu remorca" />
            <div className="util-price-content">
              <h3>Utilaje grele</h3>
            <p className="util-price-tag">350 <span>RON</span></p>
              <p className="util-price-details">(mașini autopropulsate pentru lucrări, excavatoare, buldozere, automacarale)</p>
              <button className="util-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>


        </div>
      </section>

      {/* ZONE ACOPERITE */}
      <section className="util-zones-section">
        <div className="util-zones-container">
          <div className="util-zone-card">
            <div className="util-zone-image-wrapper">
              <img src={images.zoneServicii} alt="Servicii ITP utilitare Sector 2" />
            </div>
            <h3>SERVICII UTILITARE</h3>
            <p>Autorizați RAR pentru <strong>ITP Sector 2</strong>, cu clienți frecvenți și din <strong>Sector 1</strong> și <strong>Sector 3</strong>.</p>
            <Link to="/" className="util-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
          <div className="util-zone-card">
            <div className="util-zone-image-wrapper">
              <img src={images.zoneAproape} alt="ITP utilitare aproape de mine Sector 2" />
            </div>
            <h3>ITP UTILITARE APROAPE DE MINE</h3>
            <p>La câteva minute de <strong>Pantelimon</strong>, <strong>Colentina</strong>, <strong>Obor</strong>, <strong>Iancului</strong> și <strong>Titan</strong>.</p>
            <Link to="/" className="util-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
        </div>
      </section>

      {/* ACTE NECESARE */}
      <section className="util-docs-section">
        <h2>Acte necesare pentru ITP utilitare:</h2>
        <div className="util-docs-grid">
          <div className="util-doc-item"><FaFileAlt /><span>Cartea de identitate a vehiculului (CIV)</span></div>
          <div className="util-doc-item"><FaFileContract /><span>Talonul / Certificatul de înmatriculare</span></div>
          <div className="util-doc-item"><FaFileSignature /><span>Asigurarea RCA valabilă</span></div>
          <div className="util-doc-item"><FaIdCard /><span>Actul de identitate (CI) al șoferului</span></div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ItpVehiculeUtilitarePage;